import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { SiblingFigure } from '../characters/SiblingFigure';
import { products } from '../../data/products';
interface PointScreenProps {
  onNext: () => void;
}
const needs = [{
  label: 'Control',
  product: 'Supreme',
  role: 'firstborn' as const
}, {
  label: 'Simplicity',
  product: 'Easy Match',
  role: 'middle' as const
}, {
  label: 'Efficiency',
  product: 'One Bulk Fill',
  role: 'youngest' as const
}];
export function PointScreen({
  onNext
}: PointScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-154" data-mp="2b64lmvgwyem">
      <Reveal data-id="element-155" data-mp="2dilrxtej4qm">
        <h2 className="font-heading text-[34px] leading-[1] tracking-[-0.02em] text-white" data-id="element-156" data-mp="3ti0joon0c3ep">
          But here’s the thing...
        </h2>
      </Reveal>
      <Reveal delay={0.14} data-id="element-157" data-mp="2n3hqlyf5gxp0">
        <p className="mt-5 font-heading text-[24px] leading-tight text-primary" data-id="element-158" data-mp="2mzk4r516ts1f">
          There is no best sibling.
        </p>
      </Reveal>
      <Reveal delay={0.24} data-id="element-159" data-mp="2iujnrphx73ga">
        <p className="mt-2 font-body text-[17px] leading-relaxed text-white/70" data-id="element-160" data-mp="2ivcjlvfcc8jn">
          They are just good at different things.
        </p>
      </Reveal>

      <Reveal delay={0.34} className="mt-8" data-id="element-161" data-mp="28x57pqzwsgoi">
        <div className="space-y-2.5" data-id="element-162" data-mp="28wdlh6s7bvaw">
          {needs.map((need, i) => <motion.div key={need.label} initial={{
          opacity: 0,
          x: -12
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4 + i * 0.12,
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex items-center gap-3 rounded-2xl bg-white/[0.06] px-4 py-3 ring-1 ring-white/10" data-id="element-163" data-mp="2duos78n79pow" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-end justify-center overflow-hidden rounded-full bg-white/90" data-id="element-164" data-mp="1v4z1awmk5o29">
                <SiblingFigure role={need.role} className="h-10 w-auto" data-id="element-165" data-mp="1h6ikgcuzeh6e" />
              </span>
              <span className="font-body text-[14px] text-white" data-id="element-166" data-mp="1l7awfdv8n06d">
                Some cases need <span className="text-primary" data-id="element-167" data-mp="3ntgaa55ftjej">{need.label.toLowerCase()}</span>.
              </span>
              <span className="ml-auto font-body text-[10px] uppercase tracking-[0.14em] text-white/40" data-id="element-168" data-mp="3j2howr5ldv4f">
                {need.product}
              </span>
            </motion.div>)}
        </div>
      </Reveal>

      <Reveal delay={0.8} className="mt-7" data-id="element-169" data-mp="395v607wtte51">
        <p className="font-body text-[13px] leading-relaxed text-white/50" data-id="element-170" data-mp="392qwcv0ldq6z">
          {products.length} siblings. One heritage. Pick the one the case is asking for.
        </p>
        <div className="mt-4" data-id="element-171" data-mp="5omoxq9xaibd">
          <PillButton tone="dark" full onClick={onNext} data-id="element-172" data-mp="p0c3hy0b433">
            So then...
          </PillButton>
        </div>
      </Reveal>
    </div>;
}